import { useStore } from "@nanostores/preact";
import { useEffect, useState } from "preact/hooks";
import { type AssetInfo, ApiError, searchPublicAssets } from "../net/api";
import { toggleHotbar, toggleMessage } from "../state/hotbar";
import { $settingsLoaded } from "../state/settings";
import { $panel, toast } from "../state/stores";
import { describeError } from "./errors";
import { Panel } from "./Panel";

const LICENSE_TEXT: Record<string, string> = { "cc0": "CC0", "cc-by": "CC BY", "world-only": "僅限世界內" };

export function PublicAssetsPanel() {
  const [q, setQ] = useState("");
  const [items, setItems] = useState<AssetInfo[]>([]);
  const loaded = useStore($settingsLoaded);
  const [more, setMore] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function search(reset: boolean) {
    setError(null);
    try {
      const before = reset ? undefined : items[items.length - 1]?.code;
      const page = await searchPublicAssets(q, before);
      setItems(reset ? page : [...items, ...page]);
      setMore(page.length === 20);
    } catch (e) {
      setError(e instanceof ApiError ? describeError(e.code) : "無法連線到伺服器");
    }
  }
  useEffect(() => { void search(true); }, []);

  function add(a: AssetInfo) {
    toast(toggleMessage(toggleHotbar(a.code, a.name), a.name));
  }

  return (
    <Panel title="公開資產" onClose={() => $panel.set(null)}>
      <form onSubmit={(e) => { e.preventDefault(); void search(true); }}>
        <input type="text" placeholder="搜尋名稱" value={q} onInput={(e) => setQ((e.target as HTMLInputElement).value)} />
        <button type="submit">搜尋</button>
      </form>
      {items.length === 0 && !error && <p class="hint">沒有符合的公開資產。</p>}
      <table>
        <tbody>
          {items.map((a) => (
            <tr key={a.code}>
              <td>{a.name}<br /><code>{a.code}</code></td>
              <td>{a.owner_name}<br />{LICENSE_TEXT[a.license] ?? a.license}</td>
              <td><button disabled={!loaded} onClick={() => add(a)}>快捷列</button></td>
            </tr>
          ))}
        </tbody>
      </table>
      {more && <button class="secondary" onClick={() => void search(false)}>更多</button>}
      {error && <div class="error">{error}</div>}
    </Panel>
  );
}
